@import '../../../theme.scss';

verdocs-question-dialog {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  box-sizing: border-box;
  font-family: $primary-font;

  &.closed {
    display: none;
  }

  textarea {
    box-sizing: border-box;
    border: 1px solid $border-color;
    border-radius: 4px;
    background: $verdocs-grey-4;
    color: #000;
    width: 100%;
    font-size: 14px;
    padding: 9px;
    outline: none;
  }

  .heading .title {
    font-size: 18px;
  }

  .buttons {
    gap: 20px;
    display: flex;
    margin-top: 24px;
    flex-direction: row;
    justify-content: center;

    button {
      flex: 1;
      border: 0;
      height: 38px;
      display: flex;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
      border-radius: 6px;
      align-items: center;
      justify-content: center;

      &.cancel {
        background-color: $verdocs-button-purple;
      }

      &.ok {
        background-color: $verdocs-button-green;

        &.single {
          max-width: 150px;
        }
      }

      &:disabled {
        background-color: $verdocs-button-disabled;
      }
    }
  }
}
